module.exports = __webpack_public_path__ + "static/media/warning.ac0bf8d1.svg";